import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { USER_QUERIES } from '@/app/platform/platform-core/user/store/types';
import { hasFeature } from '@/app/support/support-access.service';
import { SHARE_CHARTS_FEATURE_ID } from './hd-chart-share.models';

/**
 * Toegang tot "charts delen": de UPAM-feature bepaalt of de deelknoppen bestaan
 * (shortcutbalk, manager-rij, overzicht van gedeelde charts). Zonder feature is
 * delen onzichtbaar; bestaande deellinks blijven werken en een deellink bekijken
 * blijft voor elke ingelogde gebruiker open.
 */
@Injectable({ providedIn: 'root' })
export class HdChartShareAccessService {
  // Optioneel: in component-specs zonder user-store is er simpelweg geen
  // toegang, in plaats van een injectiefout.
  private readonly userQueries = inject(USER_QUERIES, { optional: true });

  readonly featureGranted: Signal<boolean> = this.granted(SHARE_CHARTS_FEATURE_ID);

  private granted(featureId: string): Signal<boolean> {
    if (this.userQueries == null) {
      return computed(() => false);
    }
    return toSignal(
      combineLatest([this.userQueries.isAnyUserAuthenticated$, this.userQueries.availableApps$]).pipe(
        map(([authenticated, apps]) => authenticated && hasFeature(apps, featureId)),
      ),
      { initialValue: false },
    );
  }
}
